import React from 'react';
import cn from 'classnames';
import { WrapperBanner } from './index';
import style from './index.module.scss';
import Contact from 'components/contact';
import Transition, { TProps } from 'components/transition';
interface Props {
  mUrl: string;
  pcUrl: string;
  type?: number;
  title?: string;
  mTitle?: string;
  desc: string;
  imageHost?: string;
  className?: string;
  mDesc?: string;
  descCenter?: boolean;
  isMCenter?: boolean;
  isTry?: boolean;
}

const MultipleBanner = (prop: Props & Omit<TProps, 'children'>) => {
  const { mUrl, pcUrl, type = 1, title = '', mTitle = '', desc, imageHost = '', mDesc = '', animate = 'none', delay = 0, offset = 0, descCenter = false, isMCenter = false, isTry = false } = prop;
  const children = () => {
    return (
      <div className={cn('multiple-content', `multiple-content-${type}`)}>
        <Transition delay={delay} offset={offset} animate={animate}>
          <div className={cn('big-title', 'for-pc')} dangerouslySetInnerHTML={{ __html: title.replace(/\n/g, '<br/>') }}></div>
          <div
            className={cn('big-title', 'for-mobile')}
            dangerouslySetInnerHTML={{
              __html: !mTitle ? title.replace(/\n/g, '<br>') : mTitle.replace(/\n/g, '<br>'),
            }}
          ></div>
        </Transition>
        <Transition delay={delay + 0.3} offset={offset} animate={animate}>
          <div
            className={cn('font-normal', 'for-pc', descCenter && 'center')}
            dangerouslySetInnerHTML={{
              __html: desc.replace(/\n/g, '<br>'),
            }}
          ></div>
        </Transition>
        <Transition delay={delay + 0.3} offset={offset} animate={animate}>
          <div
            className={cn('font-normal', 'for-mobile', isMCenter && 'center')}
            dangerouslySetInnerHTML={{
              __html: !mDesc ? desc.replace(/\n/g, '<br>') : mDesc.replace(/\n/g, '<br>'),
            }}
          ></div>
        </Transition>
        {type === 1 && (
          <div className={'contact'}>
            <Contact isTry={isTry} btnType="newBtn" />
          </div>
        )}
      </div>
    );
  };

  return (
    <WrapperBanner
      bannerInfo={{
        mUrl: imageHost + mUrl,
        pcUrl: imageHost + pcUrl,
        classNames: cn(style.MBanner, type === 1 && style.first, prop.className),
      }}
    >
      {children()}
    </WrapperBanner>
  );
};

export default MultipleBanner;
